// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","fadeIn":"Footer_fadeIn__TkZ2c"};